import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";
import { showToast } from "../components/ui/toast";

export const useGetWaitlistQuery = () => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_WAITLIST],
    queryFn: () => api.get(API_ROUTES.GET_WAITLIST),
  });
  return { data: data?.data?.data ?? [], isPending, isError, error };
};

export const useUpdateWaitlistMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } = useMutation({
    mutationFn: (data) => api.put(`${API_ROUTES.UPDATE_WAITLIST}/${data?.id}`, {
      name: data?.name,
      email: data?.email,
      details: data?.details,
      isContacted: data?.isContacted,
    }),
    onSuccess: () => {
      showToast("success", "Waitlist entry updated successfully");
    },
    onSettled: () => {
      queryClient.invalidateQueries(API_ROUTES.GET_WAITLIST);
    },
  });
  return { mutate, isError, error, isLoading, isSuccess, isPending };
};

export const useDeleteWaitlistMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess } = useMutation({
    mutationFn: (id) => api.delete(`${API_ROUTES.DELETE_WAITLIST}/${id}`),
    onSuccess: () => {
      showToast("success", "Waitlist entry deleted successfully");
    },
    onSettled: () => {
      queryClient.invalidateQueries(API_ROUTES.GET_WAITLIST);
    },
  });
  return { mutate, isError, error, isLoading, isSuccess };
};

export const useAddWaitlistMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess } = useMutation({
    mutationFn: (data) => api.post(`${API_ROUTES.CREATE_WAITLIST}`, {
      name: data?.name,
      email: data?.email,
      phone: data?.phone,
      region: data?.region,
      details: data?.details,
      isContacted: data?.isContacted,
    }),
    onSuccess: () => {
      showToast("success", "Waitlist entry created successfully");
    },
    onSettled: () => {
      queryClient.invalidateQueries(API_ROUTES.GET_WAITLIST);
    },
  });
  return { mutate, isError, error, isLoading, isSuccess };
};
